import { createSelector } from 'reselect';
import ConsignmentReceptacleDetailsColumns from '../../containers/ConsignmentReceptacleDetailsColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state.reporting.CONSIGNMENT_RECEPTACLE_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.CONSIGNMENT_RECEPTACLE_DETAILS.isLoading;

export const getData =
  ReportDefinitions.CONSIGNMENT_RECEPTACLE_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, ConsignmentReceptacleDetailsColumns);
